import { differenceInYears, isBefore, parseISO } from 'date-fns';

import type { Store } from '@jane/shared/types';

import { formatBirthdate } from '../dates/formatBirthdate';

const minimumDateValidation = (date?: string) => {
  if (!date) {
    return false;
  }

  return isBefore(parseISO(date), parseISO('1900-01-01'));
};

type MinimumAgeValidationProps = {
  ageMinimum: number;
  value?: string;
};

const minimumAgeValidation = ({
  value,
  ageMinimum,
}: MinimumAgeValidationProps) => {
  if (!value) return false;

  return differenceInYears(new Date(), parseISO(value)) >= ageMinimum;
};

export const validateBirthdateField = (value: string, store: Store) => {
  const birthDate = formatBirthdate(value);

  const isDateBefore1900 = minimumDateValidation(birthDate);

  if (isDateBefore1900) {
    return 'You must be born after 1900';
  }

  const meetsMinimumAgeRequirement = minimumAgeValidation({
    ageMinimum: store.checkout_age_minimum,
    value: birthDate,
  });

  return (
    meetsMinimumAgeRequirement ||
    `Minimum age must be ${store.checkout_age_minimum}`
  );
};
